"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleIcon = exports.showPassword = exports.passwordWrapper = exports.error = exports.forgotPassword = exports.mobile = exports.actions = void 0;

var _react = require("@emotion/react");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  right: 5px;\n  top: 31px;\n  position: absolute;\n  border: none;\n  background: none;\n  cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: red;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 22px;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  bottom: 24px;\n  color: red;\n  margin-top: 0;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 52px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var actions = (0, _react.css)(_templateObject());
exports.actions = actions;
var mobile = (0, _react.css)(_templateObject2());
exports.mobile = mobile;
var forgotPassword = (0, _react.css)(_templateObject3());
exports.forgotPassword = forgotPassword;
var error = (0, _react.css)(_templateObject4());
exports.error = error;
var passwordWrapper = (0, _react.css)(_templateObject5());
exports.passwordWrapper = passwordWrapper;
var showPassword = (0, _react.css)(_templateObject6());
exports.showPassword = showPassword;
var visibleIcon = (0, _react.css)(_templateObject7());
exports.visibleIcon = visibleIcon;